import { render, staticRenderFns } from "./outboundgoods.vue?vue&type=template&id=1e2b32ed&scoped=true&"
import script from "./outboundgoods.vue?vue&type=script&lang=js&"
export * from "./outboundgoods.vue?vue&type=script&lang=js&"
import style0 from "./outboundgoods.vue?vue&type=style&index=0&id=1e2b32ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2b32ed",
  null
  
)

export default component.exports